import { SearchParameter } from './search-parameter.model';

export class BulkDocAddPayload {
  docIds: string[];
  filterId: string;
  selectAll: boolean;
  searchParameter?: SearchParameter;
  expandEmailFamily?: boolean;
}
